import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FieldStringOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldStringOutlined";
import AntdIcon from "../components/AntdIcon";
var FieldStringOutlined = function FieldStringOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldStringOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FieldStringOutlined.displayName = 'FieldStringOutlined';
}
export default /*#__PURE__*/React.forwardRef(FieldStringOutlined);